module.exports = __webpack_public_path__ + "static/media/header.596ab4cc.png";